<h2 class="title">Przypomnienie hasła</h2>
<div class="password-reminder-page-holder">
  <!-- Header Section -->
  <div class="password-reminder-header">

    <p>Wprowadź swój adres email, aby otrzymać link do zresetowania hasła.</p>
  </div>

  <!-- Two Column Layout -->
  <div class="password-reminder-grid">

    <!-- Column 1: Password Reminder Form -->
    <div class="password-reminder-column form-column">
      <div class="column-header">
        <mat-icon class="header-icon">lock_reset</mat-icon>
        <h2>Reset hasła</h2>
      </div>
      <div class="column-content">
        @if (!successMessage) {
          <form [formGroup]="reminderForm" (ngSubmit)="onSubmit()">
            <!-- Email Field -->
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Adres email</mat-label>
              <mat-icon matPrefix>email</mat-icon>
              <input matInput formControlName="email" placeholder="Wprowadź swój e-mail" required>
              @if (reminderForm.get('email')?.hasError('required')) {
                <mat-error>
                  E-mail jest wymagany.
                </mat-error>
              }
              @if (reminderForm.get('email')?.hasError('email')) {
                <mat-error>
                  Proszę wprowadzić poprawny adres e-mail.
                </mat-error>
              }
            </mat-form-field>
            <!-- CAPTCHA Field -->
            <div class="captcha-container">
              <p>{{ captchaQuestion }}</p>
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Zabezpieczenie przed spamem. Twoja odpowiedź</mat-label>
                <input matInput formControlName="captcha" />
                @if (reminderForm.get('captcha')?.hasError('required')) {
                  <mat-error>
                    Odpowiedź jest wymagana
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <!-- Submit Button -->
            <button class="custom-button" mat-raised-button type="submit" [disabled]="reminderForm.invalid">
              Wyślij przypomnienie
            </button>
          </form>
        }

        <!-- Success Message -->
        @if (successMessage) {
          <div class="success-message">
            <mat-icon color="primary" style="vertical-align: middle;">check_circle</mat-icon>
            <span style="margin-left: 8px;">{{ successMessage }}</span>
          </div>
        }

        <!-- Back to login link -->
        <div class="back-to-login">
          <a routerLink="/logowanie">&#9664; Powrót do logowania</a>
        </div>
      </div>
    </div>

    <!-- Column 2: Password Security Tips -->
    <div class="password-reminder-column tips-column">
      <div class="column-header">
        <mat-icon class="header-icon">tips_and_updates</mat-icon>
        <h2>Porady bezpieczeństwa</h2>
      </div>
      <div class="column-content">
        <div class="security-info">
          <p class="security-intro">
            <strong>Jak utworzyć bezpieczne hasło:</strong>
          </p>

          <div class="security-tips">
            <div class="security-tip">
              <mat-icon class="tip-icon">format_size</mat-icon>
              <div class="tip-content">
                <h4>Długość hasła</h4>
                <p>Używaj haseł o długości minimum 8 znaków. Im dłuższe hasło, tym bezpieczniejsze</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">text_format</mat-icon>
              <div class="tip-content">
                <h4>Różnorodność znaków</h4>
                <p>Kombinuj małe i duże litery, cyfry oraz znaki specjalne (!@#$%^&*)</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">block</mat-icon>
              <div class="tip-content">
                <h4>Unikaj oczywistości</h4>
                <p>Nie używaj dat urodzenia, imion, adresów ani popularnych haseł jak "123456"</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">content_copy</mat-icon>
              <div class="tip-content">
                <h4>Unikalne hasła</h4>
                <p>Używaj różnych haseł dla różnych serwisów. Nie powtarzaj tego samego hasła</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">password</mat-icon>
              <div class="tip-content">
                <h4>Menedżer haseł</h4>
                <p>Rozważ użycie menedżera haseł do bezpiecznego przechowywania wszystkich haseł</p>
              </div>
            </div>

            <div class="security-tip">
              <mat-icon class="tip-icon">refresh</mat-icon>
              <div class="tip-content">
                <h4>Regularne zmiany</h4>
                <p>Zmieniaj hasła co kilka miesięcy, szczególnie do ważnych kont</p>
              </div>
            </div>
          </div>

          <div class="help-section">
            <h4>Dalsze kroki:</h4>
            <p>Po otrzymaniu emaila z linkiem do resetowania hasła:</p>
            <ol class="steps-list">
              <li>Sprawdź swoją skrzynkę pocztową (również folder spam)</li>
              <li>Kliknij w link otrzymany w emailu</li>
              <li>Wprowadź nowe, bezpieczne hasło</li>
              <li>Potwierdź zmianę hasła</li>
              <li>Zaloguj się używając nowego hasła</li>
            </ol>
          </div>

          <div class="contact-section">
            <h4>Problemy z resetowaniem?</h4>
            <p>Skontaktuj się z nami:</p>
            <div class="contact-info">
              <p><mat-icon>email</mat-icon> <a href="mailto:biuro@zgranegrono.pl">biuro@zgranegrono.pl</a></p>
              <p><mat-icon>phone</mat-icon> <a href="tel:683200630">68 320 06 30</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>